import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/emails",
    name: ROUTE_NAME.EMAILS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.EMAIL_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.EMAIL_LIST,
        component: () => import("./views/EmailListView.vue"),
      },
      {
        path: "new",
        name: ROUTE_NAME.EMAIL_COMPOSE,
        component: () => import("./views/EmailComposeView.vue"),
        // Draft edits reopen the composer via ?draft=<id> (survives refresh);
        // MAI-5037's Duplicate/Follow-Up actions pass prefill via history
        // state so the composer starts as a brand-new unsaved email.
        props: (route) => ({
          draftId: (route.query.draft as string) || undefined,
          prefill: history.state?.prefill,
        }),
      },
    ],
  },
];
